if (typeof TermsAndConditionsToggle !== 'function') {

  const TERMS_CHANGED = 'terms-checkbox:change';

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.errorMessage = this.querySelector('[data-js-terms-error]');
      // Prefer a button nested inside this element — the sticky bar wraps its
      // own — then fall back to the parent, where the summary panel and the
      // drawer footer keep theirs as a sibling. A parent lookup alone would
      // reach a nested button too, but it takes the first in document order,
      // which may belong to someone else. Never document-wide: the cart page
      // renders both the panel and the drawer.
      this.checkoutButton = this.querySelector('[name="checkout"]')
        || (this.parentElement || document).querySelector('[name="checkout"]');

      if (!this.checkbox || !this.checkoutButton) return;

      // The button ships disabled so consent can't be skipped before this runs.
      // From here on it stays clickable and we validate on click instead, so an
      // unchecked box gives the shopper a reason rather than a dead button.
      this.checkoutButton.disabled = false;

      this.checkbox.addEventListener('change', () => {
        this.sync();
        document.dispatchEvent(new CustomEvent(TERMS_CHANGED, {
          detail: { source: this, checked: this.checkbox.checked }
        }));
      });

      // The cart page renders this component more than once — in the summary
      // panel and in the sticky bar — and each drives its own checkout button.
      // Without this, consent given in one place would leave the other locked.
      this.onTermsChanged = (event) => {
        if (event.detail.source === this) return;
        if (this.checkbox.checked === event.detail.checked) return;
        this.checkbox.checked = event.detail.checked;
        this.sync();
      };
      document.addEventListener(TERMS_CHANGED, this.onTermsChanged);

      this.checkoutButton.addEventListener('click', (event) => {
        if (this.checkbox.checked) return;
        event.preventDefault();
        this.showError();
      });
    }

    disconnectedCallback() {
      document.removeEventListener(TERMS_CHANGED, this.onTermsChanged);
    }

    sync() {
      if (this.checkbox.checked) this.hideError();
    }

    showError() {
      this.checkbox.setAttribute('aria-invalid', 'true');
      if (this.errorMessage) this.errorMessage.hidden = false;
      this.checkbox.focus();
    }

    hideError() {
      this.checkbox.removeAttribute('aria-invalid');
      if (this.errorMessage) this.errorMessage.hidden = true;
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}
